import React, {useEffect, useState} from 'react';
import {getCountries, getCountryCallingCode, isValidPhoneNumber, parsePhoneNumberFromString} from 'libphonenumber-js';
import {useUserClient} from '../../../../react-hooks/useUserClient';

const START = 0x1f1e6 - 0x41;

const PhoneDisplay = ({value}) => {
    const [country, setCountry] = useState(null);
    const [number, setNumber] = useState(value);
    const [tel, setTel] = useState('');
    const [numberValid, setNumberValid] = useState('');
    const [emoji, setEmoji] = useState('');
    const [user] = useUserClient();

    useEffect(() => {
        const updatePhoneDisplay = async () => {
            if (!user) {
                return;
            }
            setCountry(null);
            setNumber(value);
            if (!user) {
                return;
            }
            if (value) {
                setTel('tel:' + value.replaceAll('-', ''));
            }

            const userCountry = await user?.getCountry();
            try {
                const parsed = parsePhoneNumberFromString(value, userCountry);
                let phoneCountry = parsed && parsed.country;

                let countries = {};

                for (let country of getCountries()) {
                    let cc = getCountryCallingCode(country);

                    if (!countries[cc]) {
                        countries[cc] = [];
                    }

                    countries[cc].push(country);
                }

                if (!phoneCountry && countries?.[parsed.countryCallingCode]?.[0]) {
                    phoneCountry = countries?.[parsed.countryCallingCode]?.[0];
                }

                if (!isValidPhoneNumber(parsed.number, phoneCountry)) {
                    setNumberValid('(ungültige Rufnummer)');
                }

                if (!phoneCountry) {
                    return;
                }

                const userData = await user.getUser();

                if (
                    userData.settings?.userSettings?.showLocalNumber &&
                    phoneCountry === userCountry
                ) {
                    setNumber(parsed.formatNational());
                } else {
                    setCountry(phoneCountry);
                    setEmoji(
                        String.fromCodePoint(
                            START + phoneCountry.charCodeAt(0),
                            START + phoneCountry.charCodeAt(1)
                        )
                    );
                }
            } catch (e) {
                console.error(e);
            }
        };

        updatePhoneDisplay();
    }, [value, user]);

    return (
        <>
            <a href={tel} className="phone-number">
                {country && <abbr title={country}>{emoji}</abbr>}
                {number}
            </a>
            {numberValid}
        </>
    );
};

export default PhoneDisplay;
